"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcons = exports.FooterContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _media = require("./media.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      &:first-child {\n        padding-left: 0;\n      }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    top: 0;\n    left: 0;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  top: 35px;\n  ", "\n  a {\n    padding-left: 10px;\n    color: #222 !important;\n    ", ";\n    svg {\n      background: #fff;\n      border-radius: 50%;\n      padding: 5px;\n    }\n    &:hover {\n      svg {\n        background: #fff;\n      }\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      position: relative;\n      display: block;\n      margin-top: 20px;\n      svg {\n        position: absolute;\n        top: -20px !important;\n      }\n      p {\n        padding-left: 50px;\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        display: none;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    padding: 40px 30px 30px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      &.align-right {\n        text-align: left !important;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          display: none;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        flex: 0 50%;\n        margin: 0;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      flex-wrap: wrap;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 24px 60px 30px;\n  text-align: left;\n  background: #222;\n  position: relative;\n  z-index: 10;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  ", "\n  .flex {\n    display: flex;\n    justify-content: space-between;\n    ", "\n    > div {\n      margin: 0 20px;\n      ", "\n      &.copyright {\n        position: relative;\n        top: 50px;\n        margin-right: 40px;\n        svg {\n          position: absolute;\n          top: -10px;\n        }\n        p {\n          padding-left: 30px;\n        }\n        ", "\n      }\n    }\n  }\n  .st0 {\n    fill: #fff;\n  }\n  p {\n    color: #fff;\n    font-size: 13px;\n    ", ";\n  }\n  ", ";\n\n  h3 {\n    color: #fff;\n    font-size: 14px;\n    font-weight: 300;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n  }\n  ul,\n  li {\n    list-style: none;\n    padding-left: 0;\n  }\n\n  a {\n    color: #fff;\n    font-size: 13px;\n    line-height: 200%;\n    color: #fff !important;\n    border-bottom: 0 !important;\n    transition: all 0.6s ease 0s;\n    text-decoration: none;\n    &:hover {\n      color: #00959A !important;\n    }\n  }\n\n  svg {\n    width: 18px;\n    height: 18px;\n    fill: #fff;\n    position: relative;\n    top: 5px;\n    margin-right: 3px;\n    &.logo {\n      width: 40px;\n      height: 40px;\n    }\n    &.jss172 {\n      opacity: 0.6;\n      position: relative;\n      top: 11px;\n      ", "\n    }\n  }\n  .mobile {\n    display: none;\n    ", "\n  }\n .mobileLogo {\n margin-top: -30px;\n      color: #1EBEC8 !important;\n   ", "\n }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FooterContainer = _styledComponents["default"].footer(_templateObject(), _media.media.desktop(_templateObject2()), _media.media.desktop(_templateObject3()), _media.media.desktop(_templateObject4()), _media.media.desktop(_templateObject5()), _media.media.phone(_templateObject6()), _media.media.tablet(_templateObject7()), _media.media.desktop(_templateObject8()), _media.media.desktop(_templateObject9()));

exports.FooterContainer = FooterContainer;

var SocialIcons = _styledComponents["default"].span(_templateObject10(), _media.media.desktop(_templateObject11()), _media.media.tablet(_templateObject12()));

exports.SocialIcons = SocialIcons;